import { type TableHeaderRow } from '@shared/table-generator';

export function ExamCourseAnalysisReportTableHeader(): TableHeaderRow[] {
  return [
    {
      children: [
        {
          id: 'examId',
          children: 'Exam ID',
          align: 'center',
          rowSpan: 2,
          width: 90,
        },
        {
          id: 'code',
          children: 'Exam Code',
          align: 'center',
          rowSpan: 2,
          width: 140,
        },
        {
          id: 'name',
          children: 'Exam Course Name',
          rowSpan: 2,
          align: 'left',
          sx: {
            minWidth: 440,
          },
        },
        {
          id: 'type',
          children: 'Type',
          rowSpan: 2,
          width: 80,
        },
        {
          id: 'qConfigRef',
          children: 'QConfig Ref.',
          rowSpan: 2,
          sx: {
            minWidth: 114,
          },
        },
        {
          id: 'score',
          children: 'Total Score',
          align: 'center',
          rowSpan: 2,
          sx: { minWidth: 110 },
        },
        {
          id: 'sd',
          children: 'S.D.',
          align: 'center',
          rowSpan: 2,
          sx: { minWidth: 110 },
        },
        {
          id: 'maxScore',
          children: 'Max Score',
          align: 'center',
          rowSpan: 2,
          sx: { minWidth: 110 },
        },
        {
          id: 'minScore',
          children: 'Min Score',
          align: 'center',
          rowSpan: 2,
          sx: { minWidth: 110 },
        },
        {
          id: 'averageScore',
          children: 'Avg. Score',
          align: 'center',
          rowSpan: 2,
          sx: { minWidth: 110 },
        },
        {
          id: 'examinees',
          children: 'Examinees',
          align: 'center' as const,
          colSpan: 3,
          width: 324,
        },
        {
          id: `examineesUnique`,
          children: 'Examinees (Unique)',
          align: 'center' as const,
          rowSpan: 2,
          width: 108,
        },
        {
          id: `avgAttempts`,
          children: 'Avg. Attempts',
          align: 'center' as const,
          rowSpan: 2,

          width: 108,
        },

        {
          id: 'passed',
          children: 'Passed',
          align: 'center' as const,
          colSpan: 3,
          width: 324,
        },
        {
          id: 'failed',
          children: 'Failed',
          align: 'center' as const,
          colSpan: 3,
          width: 324,
        },
        {
          id: 'passingRate',
          children: 'Passing Rate (%)',
          align: 'center' as const,
          colSpan: 3,
          width: 324,
        },
      ],
    },
    {
      children: [
        {
          id: `examinees-public`,
          children: 'Public',
          align: 'center' as const,
          width: 108,
        },
        {
          id: `examinees-inHouse`,
          children: 'In-house',
          align: 'center' as const,
          width: 108,
        },
        {
          id: `examinees-total`,
          children: 'Total',
          align: 'center' as const,
          width: 108,
        },
        {
          id: `passed-public`,
          children: 'Public',
          align: 'center' as const,
          width: 108,
        },
        {
          id: `passed-inHouse`,
          children: 'In-house',
          align: 'center' as const,
          width: 108,
        },
        {
          id: `passed-total`,
          children: 'Total',
          align: 'center' as const,
          width: 108,
        },
        {
          id: `failed-public`,
          children: 'Public',
          align: 'center' as const,
          width: 108,
        },
        {
          id: `failed-inHouse`,
          children: 'In-house',
          align: 'center' as const,
          width: 108,
        },
        {
          id: `failed-total`,
          children: 'Total',
          align: 'center' as const,
          width: 108,
        },
        {
          id: `passingRate-public`,
          children: 'Public',
          align: 'center' as const,
          width: 108,
        },
        {
          id: `passingRate-inHouse`,
          children: 'In-house',
          align: 'center' as const,
          width: 108,
        },
        {
          id: `passingRate-total`,
          children: 'Total',
          align: 'center' as const,
          width: 108,
        },
      ],
    },
  ];
}
